var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.repair ? _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "lg": "6"
    }
  }, [_c('m-select', {
    attrs: {
      "items": _vm.statusItems,
      "label": _vm.$t('objects.report.repair.status'),
      "append-icon": '',
      "readonly": "",
      "chips": "",
      "small-chips": "",
      "hide-details": ""
    },
    model: {
      value: _vm.repair.status,
      callback: function callback($$v) {
        _vm.$set(_vm.repair, "status", $$v);
      },
      expression: "repair.status"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "lg": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.report.repair.periodInDays'),
      "readonly": "",
      "hide-details": ""
    },
    model: {
      value: _vm.repair.periodInDays,
      callback: function callback($$v) {
        _vm.$set(_vm.repair, "periodInDays", $$v);
      },
      expression: "repair.periodInDays"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "lg": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.report.repair.startDate'),
      "type": "date",
      "readonly": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.repair.startDateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.repair, "startDateFormable", $$v);
      },
      expression: "repair.startDateFormable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "lg": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.report.repair.endDate'),
      "type": "date",
      "readonly": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.repair.endDateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.repair, "endDateFormable", $$v);
      },
      expression: "repair.endDateFormable"
    }
  })], 1), _vm.repair.isRentalProvided !== undefined ? _c('v-col', {
    attrs: {
      "cols": "6",
      "lg": "6"
    }
  }, [_c('m-select', {
    attrs: {
      "items": _vm.rentalProvidedItems,
      "label": _vm.$t('objects.report.repair.isRentalProvided'),
      "append-icon": '',
      "readonly": "",
      "hide-details": "",
      "chips": "",
      "small-chips": ""
    },
    model: {
      value: _vm.repair.isRentalProvided,
      callback: function callback($$v) {
        _vm.$set(_vm.repair, "isRentalProvided", $$v);
      },
      expression: "repair.isRentalProvided"
    }
  })], 1) : _vm._e(), _vm.repair.notes ? _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$t('objects.report.repair.notes'),
      "readonly": "",
      "hide-details": ""
    },
    model: {
      value: _vm.repair.notes,
      callback: function callback($$v) {
        _vm.$set(_vm.repair, "notes", $$v);
      },
      expression: "repair.notes"
    }
  })], 1) : _vm._e()], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }